module.exports = __webpack_public_path__ + "img/img_yl_brand.ad2308fb.png";